<div class="flex h-full w-full flex-col gap-1 p-2 sm:gap-2">
    <div class="flex flex-wrap items-center justify-between gap-1">
        @if (data().ShowCaption) {
            <span class="widget-header">{{
                    data().Caption
                }}</span>
        }
        <div [ngClass]="{'hidden' : reportControl()}" class="ml-auto flex items-center justify-end gap-2 sm:flex-wrap">
            @if (pwaService.isOnline()) {
                <bizz-filter [active]="(gridResultData$ | async)?.activeFilter ?? false"
                             [filterList]="data().FilterList"
                             [filterType]="filterItemType" [viewId]="data().ListOptions.ViewID" [widgetId]="data().ID"
                             [collectionsId]="data().CollectionsID"
                             [filterEnabled]="lookupData() != undefined ? lookupData()!.linkedLevel === 1 : true"
                             [searchFieldAccessible]="!reportControl()"
                             [mode]="filterMode"
                             (retrievedFilterData)="refreshFilterGrid($event)">
                </bizz-filter>

                <div class="flex justify-end">
                    <button type="button" class="cq-widget-btn-hidden hidden px-2 py-1 sm:flex" (click)="refreshGrid()">
                        <bizz-icon class="icon-button size-4" iconName="rotate-right"></bizz-icon>
                    </button>

                    @if(data().CanExport){
                        <bizz-export-button (onExport)="onExport($event)" [isDownloading]="isDownloading"
                                            [types]="supportedExportTypes()">
                        </bizz-export-button>
                    }

                    @if (data().CanAccessTrashCan) {
                        <button type="button" class="cq-widget-btn-hidden hidden px-2 py-1 sm:flex"
                                (click)="toggleTrashView()">
                            <bizz-icon
                                    class="icon-button size-4 hover:cursor-pointer hover:text-red-400 focus:text-red-400"
                                    iconName="trash-can" [class]="isTrashView ? '!text-red-500' : ''"></bizz-icon>
                        </button>
                    }
                    @if (data().CanCreate && !readOnly()) {
                        <button type="button" class="save round mx-1 min-w-8 size-8 drop-shadow-sm sm:flex"
                                (click)="newRecord()">
                            <bizz-icon class="size-4" iconName="plus"></bizz-icon>
                        </button>
                    }
                    <button type="button"
                            class="cq-widget-btn-flex px-0 py-1 hover:text-blue-600 focus:text-blue-600 sm:hidden"
                            (click)="showMobileActionsPopup.set(true)" #mobileActionsAnchor>
                        <bizz-icon
                                class="inline-block size-5 text-widget-button hover:cursor-pointer hover:text-blue-600 focus:text-blue-600"
                                iconName="ellipsis-vertical"></bizz-icon>
                    </button>
                </div>
            } @else {
                <!-- offline search -->
                <bizz-search [searchTerm]="searchTerm" (searchTermChange)="onSearchTermChange($event)"></bizz-search>
                <bizz-icon class="mr-3 size-4 cursor-pointer text-default"
                           [iconName]="offlineItemsVisible? 'eye-slash':'eye'"
                           (click)="toggleVisibilityOfflineItems()"></bizz-icon>

            }
        </div>
    </div>
    @if (showMobileActionsPopup()) {
        <kendo-popup #propertiesPopup class="z-[1004] w-auto" [anchor]="mobileAnchor" [animate]="true"
                     [margin]="{ horizontal: 0, vertical: 10 }" [collision]="{ horizontal: 'fit', vertical: 'fit' }"
                     [popupAlign]="{ horizontal: 'right', vertical: 'top' }"
                     [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }" [positionMode]="'absolute'"
                     (anchorViewportLeave)="showMobileActionsPopup.set(false)">
            <div class="bizz-popup-content">
                <button type="button" class="flex gap-4 text-nowrap px-2 py-1.5" (click)="refreshGrid()">
                    <bizz-icon class="size-5 min-w-5 sm:size-3 sm:min-w-3" iconName="rotate-right"></bizz-icon>
                    <span class="text-sm sm:text-xs">{{
                            'Refresh' | translate
                        }}</span>
                </button>
                @if (data().CanAccessTrashCan) {
                    <button type="button" class="flex gap-4 text-nowrap px-2 py-1.5" (click)="toggleTrashView()">
                        <bizz-icon class="size-5 min-w-5 sm:size-3 sm:min-w-3" iconName="trash-can"
                                   [class]="isTrashView ? '!text-red-400' : ''"></bizz-icon>
                        <span class="text-sm sm:text-xs">{{
                                'Trashcan' | translate
                            }}</span>
                    </button>
                }
                @if (data().CanExport) {
                    <hr class="my-1.5 h-[1px] border-t border-divider px-2"/>
                    <button type="button" class="flex gap-4 text-nowrap px-2 py-1.5" (click)="exportCsv()">
                        <bizz-icon class="size-5 min-w-5 text-sidebar-icon sm:size-3 sm:min-w-3"
                                   iconName="file-spreadsheet"></bizz-icon>
                        <span class="text-sm sm:text-xs">{{
                                'Export' | translate
                            }} {{
                                'CSV' | translate
                            }}</span>
                    </button>

                    <button type="button" class="flex gap-4 text-nowrap px-2 py-1.5" (click)="exportXlsx()">
                        <bizz-icon class="size-5 min-w-5 text-green-700 sm:size-3 sm:min-w-3"
                                   iconName="file-excel"></bizz-icon>
                        <span class="text-sm sm:text-xs">{{
                                'Export' | translate
                            }} {{
                                'XLSX' | translate
                            }}</span>
                    </button>
                    @if (reportsAvailableForUser) {
                        <button type="button" class="flex gap-4 text-nowrap px-2 py-1.5" (click)="exportPdf()">
                            <bizz-icon class="size-5 min-w-5 text-red-400 sm:size-3 sm:min-w-3"
                                       iconName="file-pdf"></bizz-icon>
                            <span class="text-sm sm:text-xs">{{
                                    'Export' | translate
                                }} {{
                                    'PDF' | translate
                                }}</span>
                        </button>
                    }
                }
            </div>
        </kendo-popup>
    }
    <bizz-grid (cellAction)="onCellAction($event)"
               (groupChange)="onGroupChange($event)"
               (pageChange)="onPageChange($event)"
               (selectionChange)="selectionChange.emit($event)"
               (sortChange)="onSortChange($event)"
               [autoFitColumns]="listOptions.GridColumnsAutoWidth"
               [commandColumnTemplate]="commandColumnTemplate()"
               [currentPage]="currentPage"
               [gridCellMetadata]="{ trashFilterActive: isTrashView, collectionType, listOptions, isDocumentTreeGrid: false,
        userId, userType, managerTrainingQueue: false, widgetId: data().ID }"
               [gridData]="(gridData$ | async)!"
               [gridOptions]="gridOptions"
               [loading]="loading"
               [ngClass]="{'report-control': reportControl()}"
               [readOnly]="readOnly()"
               [totalItems]="((gridResultData$ | async)?.totalItems ?? 0)"
               class="bizz-grid flex h-full flex-col overflow-hidden"></bizz-grid>
</div>